import React from 'react'
import './experience.css'
import {AiFillCheckCircle} from 'react-icons/ai'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>Skills I have</h5>
      <h2>My Experience</h2>

      <div className='container experience__container'>
        <div className='experience__languages'>
          <h3>Systems Engineering</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Linux System Architecture</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Embedded Linux Development</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Hardware Abstraction Layer (HAL) Design</h4>
                <small className='text-light'>Experienced</small>
              </div>               
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Multithreaded System Design</h4>
                <small className='text-light'>Experienced</small>
              </div>               
            </article>
          </div>
        </div>


        <div className='experience__technologies'>
        <h3>Programming</h3>
          <div className='experience__content'>

            <article className='experience__details'>
                <AiFillCheckCircle className='experience__details-icon'/>
                <div>
                  <h4>Modern C++ (System-Level Development)</h4>
                  <small className='text-light'>Professional</small>
                </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Low-level C</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Python (Automation & Engineering Tools)</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Bash (System Scripting)</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
          </div>          
        </div> 
      
        <div className='experience__tools'>
        <h3>Embedded & Hardware</h3>
          <div className='experience__content'>
          
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Microcontroller Interfacing</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
              <h4>Device Driver Interaction</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
              <h4>GPIO & Peripheral Control</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>I²C Communication</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>          
        </div> 

        <div className='experience__tools'>
        <h3>Build & Software Architecture</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Cross-layer Software Integration</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>CMake Build Systems</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>System Debugging & Performance Optimization</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Build Automation & Dependency Management</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>          
        </div> 

        <div className='experience__tools'>
        <h3>Tools</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Git & GitHub</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Linux Development Environment</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Qt Creator</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>          
        </div> 

        <div className='experience__tools'>
        <h3>Additional Engineering Capabilities</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>React.js (Technical dashboards & project showcases)</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Unit & Integration Testing</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>          
        </div> 
      </div>
    </section>
  )
}

export default Experience